import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

export { pdfjsLib };

/**
 * Render a PDF page to a JPEG data URL.
 *
 * Renders at 2x the target size and smoothly downscales — this hides the
 * hairline seams that appear when a PDF page is built from tiled images.
 *
 * Pass either `targetWidth` (thumbnails) or `scale` (full-size pages).
 * Returns { dataUrl, width, height } at the final (downscaled) size.
 */
export const renderPageToDataUrl = async (
  page,
  { targetWidth, scale, quality = 0.9 }
) => {
  const baseViewport = page.getViewport({ scale: 1 });
  const finalScale = targetWidth ? targetWidth / baseViewport.width : scale;
  const viewport = page.getViewport({ scale: finalScale * 2 });

  const large = document.createElement("canvas");
  large.width = viewport.width;
  large.height = viewport.height;
  await page.render({ canvasContext: large.getContext("2d"), viewport })
    .promise;

  const canvas = document.createElement("canvas");
  canvas.width = Math.round(viewport.width / 2);
  canvas.height = Math.round(viewport.height / 2);
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(large, 0, 0, canvas.width, canvas.height);

  return {
    dataUrl: canvas.toDataURL("image/jpeg", quality),
    width: canvas.width,
    height: canvas.height,
  };
};
